module.exports = __webpack_public_path__ + "static/img/akum_800_400.e987bf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_400.svg
// module id = +0I2
// module chunks = 1